import { State } from '../reducers/rootReducer'
import { EfficiencyDataState } from '../reducers/efficiencyDataReducer'

const efficiencyDataSelector = (state: State): EfficiencyDataState => state.efficiencyData

export default efficiencyDataSelector
